<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'CONCEPTOS.LBL_CONCEPTOS' | translate}}">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fConceptos" name="fConceptos">
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'CONCEPTOS.LBL_CODIGO' | translate }}</label>
                <div *ngIf="!concepto">
                  <input type="text" pInputText id="codigo"
                         name="nomCodigo"
                         autocomplete="off"
                         formControlName="codigo"
                         maxlength="10"
                         (blur)="validarCodigo()"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'CONCEPTOS.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                    {{ 'MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
                <div *ngIf="concepto && concepto.idConceptoFacturacion">
                  <label class="falso-combo-texto">{{concepto.codigo}}</label>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'CONCEPTOS.LBL_NOMBRE' | translate }}</label>
                <input type="text" pInputText id="nombre"
                       name="nomNombre"
                       autocomplete="off"
                       formControlName="nombre"
                       [maxlength]="50"
                       sin-caracteres-especiales-reactive
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                  {{ 'CONCEPTOS.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="grid form-group">
            <div class="col-12 md:col-3 lg:col-3">
              <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                          id="indicador"
                          name="nomIndicador"
                          formControlName="indicadorHabilitado"></p-checkbox>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <p-checkbox label="{{ 'CONCEPTOS.LBL_ANALIZAMOS' | translate}}" binary="true"
                          id="idIndicadorAnalizamos"
                          name="nomIndicadorAnalizamos"
                          formControlName="indicadorAnalizamos"></p-checkbox>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <p-checkbox label="{{ 'CONCEPTOS.LBL_DINERO' | translate}}" binary="true"
                          id="idIndicadorDinero" (onChange)="cambioDinero($event.checked)"
                          name="nomIndicadorDinero"
                          formControlName="indicadorDinero"></p-checkbox>
            </div>
            <div class="col-12 md:col-3 lg:col-3" *ngIf="f.indicadorDinero.value">
              <p-checkbox label="{{ 'CONCEPTOS.LBL_REDONDEAR' | translate}}" binary="true"
                          id="idIndicadorRedondear"
                          name="nomIndicadorRedondear"
                          formControlName="indicadorRedondear"></p-checkbox>
            </div>

          </div>
          <div class="grid form-group">
            <div class="col-12 md:col-3 lg:col-3">
              <p-checkbox label="{{ 'CONCEPTOS.LBL_RANGO' | translate}}" binary="true"
                          id="indicadorRango"
                          name="nomIndicadorRango"
                          formControlName="indicadorRango"></p-checkbox>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <p-checkbox label="{{ 'CONCEPTOS.LBL_INDICADORANUAL' | translate}}" binary="true"
                          id="idIndicadorAnual"
                          name="nomIndicadorAnual"
                          formControlName="indicadorAnual"></p-checkbox>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'CONCEPTOS.LBL_DESCRIPCION' | translate }}</label>
                <textarea pInputTextarea rows="2" id="descripcion"
                          name="descripcion"
                          autocomplete="off"
                          formControlName="descripcion"
                          maxlength="250"
                          capitalize-reactive
                ></textarea>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.invalid">
                  {{ 'CONCEPTOS.LBL_DESCRIPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-12">
              <div class="div-form">
                <p-fieldset legend="{{ 'CONCEPTOS.LBL_OPERACIONES' | translate }}">
                  <div class="col-12 md:col-6 lg:col-6">
                    <p-radioButton name="indicadorSuma" label="{{ 'CONCEPTOS.LBL_SUMA' | translate}}" formControlName="indicadorSuma"
                                   [value]="true" [disableControl]="f.codigo.value === codigosConceptos.RECCRE || f.codigo.value === codigosConceptos.SEGDES "></p-radioButton>
                  </div>
                  <div class="col-12 md:col-6 lg:col-6">
                    <p-radioButton name="indicadorSuma" label="{{ 'CONCEPTOS.LBL_RESTA' | translate}}" formControlName="indicadorSuma"
                                   [value]="false"></p-radioButton>
                  </div>
                </p-fieldset>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorSuma.invalid">
                  {{ 'CONCEPTOS.LBL_OPERACIONES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                        type="submit"
                        pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </p-panel>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
